import React, { useState } from "react";
import { CiGlobe } from "react-icons/ci";
import { IoMdArrowDropdown } from "react-icons/io";
import i18next from "i18next";
import { LanguagePage } from "./style";
import { dispatch } from "../../redux";

const languageList = [
  { id: 1, label: "UZ", type: "uz" },
  { id: 2, label: "RU", type: "ru" },
  { id: 3, label: "EN", type: "en" },
];

function Language() {
  const [activeLang, setactiveLang] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("i18nextLng")
  );

  const handleChangeLng = (lng) => {
    localStorage.setItem("i18nextLng", lng);
    i18next.changeLanguage(lng);
    setactiveLang((el) => !el);
    setSelectedLanguage(lng);

    dispatch.language.changeLanguage(lng);
  };
  return (
    <LanguagePage>
      <div className="navbarvictorina_language">
        <div
          className="navbarvictorina_language-wrapper"
          onClick={() => setactiveLang((el) => !el)}
        >
          <CiGlobe className="navbarvictorina_language-icon" />
          <span>{selectedLanguage}</span>
          <IoMdArrowDropdown className="navbarvictorina_language-iconArrow" />
        </div>
        <div
          className="navbarvictorina_language-bar"
          style={activeLang ? { display: "flex" } : null}
        >
          {languageList.map((el, index) => (
            <p
              key={index}
              onClick={() => {
                handleChangeLng(el.type);
              }}
            >
              {el.label}
            </p>
          ))}
        </div>
      </div>
    </LanguagePage>
  );
}
export default Language;
